import { html } from 'lit';
import { Link2 } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-link')
export class PdsIconLink extends PdsIcon {
  @state()
  icon = Link2;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
